import { Toaster as Sonner } from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

export function Toaster(props: ToasterProps) {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast: 'bg-white border border-navy/10 text-navy shadow-lg',
          title: 'font-display text-navy',
          description: 'font-body text-navy/70',
        },
      }}
      {...props}
    />
  );
}
